import {Action, ActionTree} from 'vuex';
import StateType from '@/store/types/StateType';

const updateLocale: Action<StateType, StateType> = async ({commit}, payload): Promise<void> => {
	await commit('updateLocale', payload);
};
const updateLocation: Action<StateType, StateType> = async ({commit}, payload): Promise<void> => {
	await commit('updateLocation', payload);
};

const updateMenu: Action<StateType, StateType> = async ({commit}, payload): Promise<void> => {
	await commit('setMenu', payload);
};

const updateAnim: Action<StateType, StateType> = async ({commit}, payload): Promise<void> => {
	await commit('updateAnim', payload);
};

const scrollToInfo: Action<StateType, StateType> = async ({commit}, payload): Promise<void> => {
	await commit('updateScrollToInfo', payload);
};

const updateGlobalState: Action<StateType, StateType> = async ({commit}, payload) => {
	await commit('setGlobalState', payload);
};

const updateAnimationCardsName: Action<StateType, StateType> = async ({commit}, payload) => {
	await commit('setAnimationCardsName', payload);
};

const updateFetching: Action<StateType, StateType> = async ({commit}, payload): Promise<void> => {
	await commit('setFetchingData', payload);
};

const addIcon: Action<StateType, StateType> = async ({commit, state}, payload: { name: string, value: string }): Promise<void> => {
	const hasInCache = await state.iconCache.has(payload.name);

	if (hasInCache) {
		return;
	}

	await commit('addIcon', payload);
};

const updateHelpCategory: Action<StateType, StateType> = async ({commit}, payload): Promise<void> => {
	await commit('setHelpCategory', payload);
};

const updateHelpSection: Action<StateType, StateType> = async ({commit}, payload): Promise<void> => {
	await commit('setHelpSection', payload);
};

const updateCardsIncluded: Action<StateType, StateType> = async ({commit}, payload): Promise<void> => {
	await commit('setCardsIncluded', payload);
};

const removeIcon: Action<StateType, StateType> = async ({commit}, name: string): Promise<void> => {
	await commit('removeIcon', name);
};


const showModal: Action<StateType, StateType> = async ({commit}, payload): Promise<void> => {
	const html = document.querySelector('html');
	html!.classList.add('is-overflow');
	await commit('setActiveModal', payload);
};

const hideModals: Action<StateType, StateType> = async ({commit}): Promise<void> => {
	const html = document.querySelector('html');
	html!.classList.remove('is-overflow');
	await commit('setActiveModal', null);
};

const updateCookies: Action<StateType, any> = async ({commit}, state) => {
	await commit('setCookies', state);
};

const updateCookiesHeight: Action<StateType, any> = async ({commit}, height) => {
	await commit('setCookiesHeight', height);
};

const headerInfo: Action<StateType, StateType> = async ({commit}, payload): Promise<void> => {
	await commit('updateHeaderInfo', payload);
};

const preloaded: Action<StateType, StateType> = async ({commit}, payload): Promise<void> => {
	await commit('setPreloaded', payload);

	if (typeof window === 'undefined') {
		return;
	}

	sessionStorage.setItem('preloaded', JSON.stringify(true));
};

const updateRecaptchaState: Action<StateType, StateType> = async ({commit}, payload): Promise<void> => {
	await commit('setRecaptchaState', payload);
};

const actions: ActionTree<StateType, StateType> = {
	updateLocale,
	addIcon,
	removeIcon,
	updateCardsIncluded,
	updateHelpCategory,
	updateHelpSection,
	updateGlobalState,
	updateFetching,
	updateRecaptchaState,
	headerInfo,
	showModal,
	hideModals,
	updateAnim,
	updateCookiesHeight,
	updateAnimationCardsName,
	updateMenu,
	updateCookies,
	updateLocation,
	scrollToInfo,
	preloaded
};

export default actions;
